import { getAllPostsLabelTranslation } from '@wix/communities-blog-client-common';
import { AppState } from '../types';
import { getQueryLocale } from './locale-selectors';

export const getViewerAllPostsLabelTranslation = (state: AppState) =>
  getQueryLocale(state)
    ? getAllPostsLabelTranslation({ state, language: getQueryLocale(state) })
    : '';
